import Vue from "vue";
import Vuex from "vuex";
import admin from "@/data/store/mixins/admin";
import detail from "@/data/store/mixins/detail";
import user from "@/data/store/mixins/user";
import page from "@/data/store/mixins/page";
import company from "@/data/store/mixins/company";
import facility from "@/data/store/mixins/facility";
import roles from "@/data/store/mixins/roles";
import doc from "@/data/store/mixins/doc";
import attach from "@/data/store/mixins/attach";
import parts from "@/data/store/mixins/parts";
import maintenance from "@/data/store/mixins/maintenance";
import engineering from "@/data/store/mixins/engineering";
import analysis from "@/data/store/mixins/analysis";
import inventory from "@/data/store/mixins/inventory";
import people from "@/data/store/mixins/people";
import limits from "@/data/store/mixins/limits";
import permits from "@/data/store/mixins/permits";
import plan from "@/data/store/mixins/plan";
import budget from "@/data/store/mixins/budget";
import tasks from "@/data/store/mixins/tasks";
import procedure from "@/data/store/mixins/procedure";
import frame from "@/data/store/mixins/frame";
import data from "@/data/store/mixins/data";
import asset from "@/data/store/mixins/asset";
import material from "@/data/store/mixins/material";
import risk from "@/data/store/mixins/risk";
import hazard from "@/data/store/mixins/hazard";
import equip from "@/data/store/mixins/equip";
import action from "@/data/store/mixins/action";
import relps from "@/data/store/mixins/relps";
import stats from "@/data/store/mixins/stats";
import trans from "@/data/store/mixins/trans";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    admin,
    analysis,
    detail,
    company,
    facility,
    asset,
    equip,
    material,
    budget,
    // part,
    relps,
    stats,
    page,
    risk,
    permits,
    plan,
    people,
    inventory,
    limits,
    tasks,
    hazard,
    procedure,
    maintenance,
    engineering,
    trans,
    frame,
    data,
    doc,
    attach,
    parts,
    roles,
    action,
    user
  }
});
